import{styled as t}from"styled-components";const n=t.div.withConfig({shouldForwardProp:t=>"alignment"!==t}).attrs({className:"button-group"})`
  padding: 3px;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: ${({alignment:t})=>"left"===(null!=t?t:"left")?"flex-start":"flex-end"};
`;export{n as ButtonGroup};
